export enum ParamHolderTypes {
  WorkflowOutput = 'workflow',
  NodeInput = 'node',
  Endpoint = 'endpoint',
}
